import { features } from './features'; 

features.applicationType = 'agrogest';

// FITOGEST
features.showAnalisis = true;
features.showMotivoFito = true;
features.showPartida = true;
features.puedeImprimir = true;
features.showRegistroTratamiento = false;
features.showRecetaGlobalGAP = true;
features.showRecetaFirmas = true;
features.showEnviarWhatsapp = true;
features.showEnviarCorreo = true;
features.showEnviarWhatsappVisitas = true;
features.showEnviarCorreoVisitas = true;
features.showTareasBio = true;
features.showMeteoBtn = true;
features.showTareasFitoSectorMultiple = true;
features.showTareasFitoMaquinarias = true;
features.showTractorMarcha = true;
features.showTractorRPM = true;
features.showTractorPresion = true;
features.showTractorBoquillas = true;
features.showRecetaPascualCabedo = true;
features.showTratamientosMenu = true;

// AGROGEST
features.showAplicadoresFichajes = true;
features.showAplicadoresPartes = true;
features.showTrabajadoresCargos = true;
features.showTareasOtros = true;
features.showTareasSiembra = true;
features.showCostes = true;
features.showCostesTareasOtrasCsv = true;
features.showCostesProductos = true;
features.showCostesTareasFertiCsv = true;
features.hasClients = true;
features.showStock = true;
features.showStockProveedor = true;
features.showStockEnvase = false;
features.showStockSemilla = true;
features.showSectorPlantas = false;
features.showProductosNumReg = false;
features.fertilizantesNombreRequired = true;
features.fertilizantesUdsMedidaRequired = true;
features.showTratamientosAllProductos = true;
features.showVisitasConsultas = true;
features.showHistoricoFT = true;
features.showExepcionales = false;
features.showOtrasDenominaciones = false;
features.showRecetaAgrogest = true;
features.showRecetaFertiAgrogest = true;
features.showStockReto = true;
features.showReto = true;
features.showStockTipoDeDato = true;

features.showMapaLabels = true;
features.showVentusky = true;
features.showMapaRutas = true;

features.showTareasSiembraProductos = true;
features.showUsuariosFirma = true;

features.showUsuariosLogs = true;
features.showClientesCrm = true;
features.showCrm = true;
features.showEstadisticas = true;
features.showVisitas = false;

features.activateREA = false;

export const environment = {
    production: true,
    v: '2',
    serverUrl: 'https://gragon.agrogest.com/',
    logoUrl: 'assets/logo_gragon.png',
    appName: 'gragon',
    features: features
};
